const TripCreateStep = Object.freeze({
  DESTINATION: "destination",
  DATE: "date",
  WITH_WHO: "with-who",
  WHAT_HAS_BEEN_BOOKED: "what-has-been-booked",
  MORE_INFO: "more-info",
} as const);

export type TripCreateStep =
  (typeof TripCreateStep)[keyof typeof TripCreateStep];

export const allTripCreateSteps: [
  TripCreateStep,
  ...TripCreateStep[],
] = Object.values(TripCreateStep) as [
  TripCreateStep,
  ...TripCreateStep[],
];

export default TripCreateStep;